import api from '../api';

import { ParamsBodyEditCustomerAppData } from 'utils/typeServices';

export const PostEditCustomerAppData = async ({ token, body }: { token: string, body: ParamsBodyEditCustomerAppData }) => {
    const bodyJson = JSON.stringify(body);

    try {
        const { data } = await api.post<{ Data: any }>('/v1/Cliente/EditCustomerAppData', bodyJson, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        return { data: data.Data };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}
